import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Button, Grid} from '@material-ui/core';
import CommonModal from 'components/common/CommonModal';
import {readUserAgreement} from 'api/account';
import {addFlashMessage} from 'actions/flash-message';
import {formatErrors} from 'actions/errors';
import {fetchCurrentAccount, logout} from '../actions/account';

class UserAgreement extends React.Component {
  constructor() {
    super();
    this.accept = this.accept.bind(this);
    this.decline = this.decline.bind(this);
  }

  accept() {
    const {fetchCurrentAccount, formatErrors} = this.props;
    const {
      router: {
        history: {push},
      },
    } = this.context;
    readUserAgreement()
      .then(fetchCurrentAccount)
      .then(() => push('/'))
      .catch((err) => formatErrors(err));
  }

  decline() {
    const {logout, formatErrors} = this.props;
    const {
      router: {
        history: {push},
      },
    } = this.context;
    logout()
      .then(() => push('/'))
      .catch((err) => formatErrors(err));
  }

  render() {
    return (
      <CommonModal title="Please Read User Agreement" onClose={this.decline} show>
        <div className="user-agreement">
          <h3 className="text-center">Terms of Use</h3>
          <ol start="1">
            <li>
              Kluwell Publications Pty Ltd (ACN 084 579 715) (Kluwell, us, our) has developed the “My Home Reading App”
              application, (the App) hosted at https://app.kluwell.com (the Website) and related services.
            </li>
            <li>
              The App is provided to you on the following terms (Terms of Use). By accepting these Terms of Use, or
              otherwise accessing the App and the related services, you agree to be bound by the Terms of Use.
            </li>
          </ol>
          <h5 className="subsection1">Licence and Restrictions</h5>
          <ol start="3">
            <li>
              Subject to the trial period and/or payment of the licence fee, Kluwell grants you a non-exclusive,
              non-transferable, revocable licence to use the App (Licence) in accordance with the terms and conditions
              of this Agreement for the trial period or set user term.
            </li>
            <li>
              At least 30 days prior to the end of the Term, you or your school will receive a notification from us that
              your Term is expiring, in which case you will need to renew your Licence for your access to continue.
            </li>
            <h5 className="subsection2">You must not:</h5>
            <ol type="a">
              <li>
                use the App or the Website for any purpose or in any manner other than for your personal or educational
                use. The App is not to be re-sold or re-distributed under any circumstances;
              </li>
              <li>
                use the App or the Website in any way that could damage the reputation of Kluwell or the goodwill or
                other rights associated with the App;
              </li>
              <li>permit any third party to use the App;</li>
              <li>
                use the App or Website in any matter or for any purpose that violates any law or regulation, promotes
                illegal activities, violates third party rights or terms of service, violates any right of any person,
                including but not limited to intellectual property rights, rights of privacy, or in any manner
                inconsistent with these Terms of Use;
              </li>
              <li>
                permit any person to link to any page containing part of the App (including via a hyperlink or RSS feed)
                without Kluwell’s prior written consent;
              </li>
              <li>
                except as expressly permitted by these Terms of Use, and except to the extent that applicable laws,
                including the Copyright Act 1968 (Cth), prevent us restraining you from doing so:
              </li>
              <ol type="i">
                <li>
                  reproduce, make error corrections to, de-compile, disassemble or otherwise reverse engineer the App or
                  create any derivative works based upon the App or the Website or permit any third party to do so;
                </li>
                <li>modify or remove any copyright or proprietary notices on the App or the Website; or</li>
                <li>
                  distribute the outputs generated from the App for other than your educational, personal or business
                  purposes.
                </li>
              </ol>
            </ol>
          </ol>
          <h5 className="subsection1">Licence and Restrictions</h5>
          <ol start="6">
            <li>You acknowledge and agree that:</li>
            <ol type="a">
              <li>
                all intellectual property rights (including all copyright, patents, trade marks, design rights trade
                secrets, domain names, know how any other rights of a similar nature, whether registrable or not and
                whether registered or not) (Intellectual Property Rights) and other proprietary rights in the App,
                Website and any modifications, updates or new releases of the App, and the source code of the App are
                owned exclusively by Kluwell;
              </li>
              <li>
                you have no right, title or interest in the App other than the rights as licensee under these Terms of
                Use;
              </li>
              <li>
                Kluwell may in its absolute discretion manage and administer the App (including all Intellectual
                Property Rights) as the exclusive owner;
              </li>
              <li>
                there is no transfer of title or ownership to you of the App or any modifications, updates or new
                releases of the App or the source code of the App; and
              </li>
              <li>
                if you learn that a third party is infringing the Intellectual Property Rights in the App or the
                Website, you will promptly notify Kluwell in writing.
              </li>
            </ol>
            <li>You warrant that in using the App, you will:</li>
            <ol type="a">
              <li>
                act at all times to protect the value in the App and ensure that the Intellectual Property Rights and
                other proprietary rights in the App are not infringed in any way; and
              </li>
              <li>comply with the directions of Kluwell in relation to the use of the App and the Website.</li>
            </ol>
          </ol>
          <h5 className="subsection1">Confidentiality</h5>
          <ol start="8">
            <li>
              You acknowledge that the App and the Documentation are commercially valuable assets which contain
              Intellectual Property Rights and confidential information (including the App, the outputs produced by the
              App, all information provided by Kluwell about the App) (Confidential Information).
            </li>
            <li>You agree to protect and not to disclose the Confidential Information unless it:</li>
            <ol type="a">
              <li>becomes available to the public (other than because of your breach of these Terms of Use);</li>
              <li>was in your possession prior to receipt from Kluwell; or</li>
              <li>is required to be disclosed to the Licensee’s authorised agents or by law.</li>
            </ol>
          </ol>
          <h5 className="subsection1">Privacy</h5>
          <ol start="10">
            <li>
              Kluwell maintains a policy of strict confidence concerning personal information it may collect in the
              provision of its services under these Terms of Use. Any collection, storage, use and dissemination of
              personal information will be in accordance with Kluwell’s Privacy Policy which can be found at: and as
              otherwise permitted under the Privacy Act 1988 (Cth).
            </li>
          </ol>
          <h5 className="subsection2">Liability</h5>
          <ol start="11">
            <li>
              To the extent permitted by law, Kluwell’s liability against any and all costs, claims, losses, liabilities
              and expenses that may arise out of or in connection with use of the App or the Website or any data
              contained in the App is limited to the licence fee paid by you.
            </li>
          </ol>
          <h5 className="subsection2">Schedule 1Indemnity</h5>
          <ol start="12">
            <li>
              You will be at all times (including upon expiry or termination of these Terms of Use) liable to Kluwell
              for, and must indemnify and keep Kluwell, and its respective officers, employees and agents, indemnified
              from and against, any loss (including legal costs and expenses), damages, claims or liability incurred or
              suffered by Kluwell or its respective officers, employees and agents in connection with:
            </li>
            <ol type="a">
              <li>any breach by you of these Terms of Use; or</li>
              <li>
                any suit, action or proceeding by any person against Kluwell where such loss or liability was caused by
                your negligent or wilful act or omission in connection with these Terms of Use.
              </li>
            </ol>
          </ol>
          <h5 className="subsection2">Termination</h5>
          <ol start="13">
            <li>
              Kluwell may terminate these Terms of Use immediately by written notice if you breach these Terms of Use:
            </li>
            <ol type="a">
              <li>
                in a manner capable of remedy, and do not remedy that breach within 10 Business Days of being requested
                by Kluwell in writing to do so; or
              </li>
              <li>where that breach is not capable of remedy.</li>
            </ol>
            <li>You may terminate these Terms of Use without cause at any time by providing notice to Kluwell.</li>
            <li>
              You may terminate these Terms of Use immediately by written notice if Kluwell breaches these Terms of Use:
            </li>
            <ol type="a">
              <li>
                in a manner capable of remedy, and Kluwell does not remedy that breach within 10 Business Days of being
                requested by you in writing to do so; or
              </li>
              <li>where that breach is not capable of remedy.</li>
            </ol>
            <li>
              Where these Terms of Use are terminated for the reasons outlined in clause 13 or 14 above or upon
              expiration:
            </li>
            <ol type="a">
              <li>any Licence Fees which have already been paid to access the App will not be refunded by Kluwell;</li>
              <li>
                the licence granted to will automatically terminate and Kluwell may prevent you from accessing the App
                (including by deactivating all and/or any part of the App and/or changing any access codes); and
              </li>
              <li>Clauses 9, 10 and 12 are intended to survive the termination or expiration of these Terms of Use.</li>
            </ol>
          </ol>
          <h5 className="subsection2">General</h5>
          <ol start="17">
            <li>The following general clauses apply in relation to this these Terms of Use:</li>
            <ol type="a">
              <li>
                These Terms of Use constitute the entire agreement between the parties and supersede any prior
                representations, understandings or arrangements made between the parties, whether orally or in writing.
              </li>
              <li>
                Kluwell may vary these Terms of Use at any time. If the variation will materially affect your use of the
                App, Kluwell will notify you of the variation and if the variation would cause you material detriment,
                you may terminate this agreement in accordance with clause 15. Otherwise, your continued use of the App
                will constitute acceptance of that variation.
              </li>
              <li>
                A right created by these Terms of Use cannot be waived except in writing signed by the party entitled to
                that right. Delay by a party in exercising a right does not constitute a waiver of that right, nor will
                a waiver (either wholly or in part) by a party of a right operate as a subsequent waiver of the same
                right or of any other right of that party.
              </li>
              <li>
                If any clause or part of any clause is in any way unenforceable, invalid or illegal, it is to be read
                down so as to be enforceable, valid and legal. If this is not possible, the clause (or where possible,
                the offending part) is to be severed from these Terms of Use without affecting the enforceability,
                validity or legality of the remaining clauses (or parts of those clauses) which will continue in full
                force and effect.
              </li>
              <li>
                Nothing in these Terms of Use creates a joint venture, partnership, or the relationship of principal and
                agent, or employee and employer between the parties; and no party has the authority to bind any other
                party by any representation, declaration or admission, or to make any contract or commitment on behalf
                of any other party or to pledge any other party’s credit.
              </li>
              <li>
                The laws applicable in Victoria govern these Terms of Use. The parties submit to the non-exclusive
                jurisdiction of the courts of Victoria and any courts competent to hear appeals from those courts.
              </li>
            </ol>
          </ol>
        </div>
        <Grid container direction="row" justify="flex-end" alignItems="center" spacing={2}>
          <Grid item>
            <Button variant="contained" onClick={this.decline}>
              Decline
            </Button>
          </Grid>
          <Grid>
            <Button variant="contained" color="primary" onClick={this.accept}>
              Accept
            </Button>
          </Grid>
        </Grid>
      </CommonModal>
    );
  }
}

UserAgreement.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  formatErrors: (...args) => dispatch(formatErrors(...args)),
  addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
  fetchCurrentAccount: (...args) => dispatch(fetchCurrentAccount(...args)),
  logout: (...args) => dispatch(logout(...args)),
});

export default connect(null, mapDispatchToProps)(UserAgreement);
